export default "__VITE_ASSET__Cy6T5jrF__"